var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SvgIcon } from "./components/svg-icon/svg-icon";
import { ReactElementFactory } from "./element-factory";
import { ReactSurveyElement } from "./reactquestion_element";
var SurveyTimerPanel = /** @class */ (function (_super) {
    __extends(SurveyTimerPanel, _super);
    function SurveyTimerPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.circleLength = 440;
        return _this;
    }
    SurveyTimerPanel.prototype.getStateElement = function () {
        return this.timerModel;
    };
    Object.defineProperty(SurveyTimerPanel.prototype, "timerModel", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyTimerPanel.prototype, "progress", {
        get: function () {
            return -this.timerModel.progress * this.circleLength;
        },
        enumerable: false,
        configurable: true
    });
    SurveyTimerPanel.prototype.render = function () {
        if (!this.timerModel.isRunning) {
            return null;
        }
        var result = React.createElement("div", { className: this.timerModel.survey.getCss().timerRoot }, this.timerModel.text);
        if (this.timerModel.showTimerAsClock) {
            var style = { strokeDasharray: this.circleLength, strokeDashoffset: this.progress };
            var progress = (this.timerModel.showProgress ? React.createElement(SvgIcon, { className: this.timerModel.getProgressCss(), style: style, iconName: "icon-timercircle", size: "auto" }) : null);
            result =
                (React.createElement("div", { className: this.timerModel.rootCss },
                    progress,
                    React.createElement("div", { className: this.timerModel.textContainerCss },
                        React.createElement("span", { className: this.timerModel.majorTextCss }, this.timerModel.clockMajorText),
                        (this.timerModel.clockMinorText ? React.createElement("span", { className: this.timerModel.minorTextCss }, this.timerModel.clockMinorText) : null))));
        }
        return result;
    };
    return SurveyTimerPanel;
}(ReactSurveyElement));
export { SurveyTimerPanel };
ReactElementFactory.Instance.registerElement("sv-timerpanel", function (props) {
    return React.createElement(SurveyTimerPanel, props);
});
